/* Native scrolling owns progress for mouse, trackpad and touch; no delayed correction. */
(() => {
 'use strict';
 window.MxExperienceScroll=(root,current,select,cleanup)=>{
  const section=root.closest('.shopify-section'),canvas=section?.querySelector(':scope > .design-content');
  const items=[...root.querySelectorAll('.feature-item')],media=root.querySelector('.feature-media');
  if(!canvas||items.length<2)return;
  const controller=new AbortController(),{signal}=controller;
  const mobile=matchMedia('(max-width:767px)');
  const navigation=document.createElement('nav');navigation.className='mxe-scroll-navigation';navigation.setAttribute('aria-label','Experience pages');
  navigation.innerHTML='<button type="button" aria-label="Previous experience">↑</button><span></span><button type="button" aria-label="Next experience">↓</button>';
  root.querySelector('.feature-stage').append(navigation);
  const buttons=navigation.querySelectorAll('button'),label=navigation.querySelector('span');
  const hint=document.createElement('p');hint.className='mxe-scroll-hint';hint.textContent='Scroll to explore ↓';navigation.before(hint);
  let span=500,nav=44,frame=0,alive=true;
  const enabled=()=>!document.body.classList.contains('mxw-editor');
  const dimensions={topic_1:[756,678],topic_3:[991,734],topic_6:[380,601],topic_4:[756,678],topic_5:[474.43,630.33]};
  function status(index){
   label.textContent=`${index+1} / ${items.length} · ${items[index].querySelector('h3').textContent.trim()}`;
   buttons[0].disabled=index===0;buttons[1].disabled=index===items.length-1;
   hint.textContent=index===items.length-1?'Scroll to continue ↓':'Scroll to explore ↓';
  }
  function read(){
   if(frame||!enabled())return;
   frame=requestAnimationFrame(()=>{
    frame=0;const distance=nav-section.getBoundingClientRect().top;
    const index=Math.max(0,Math.min(items.length-1,Math.floor(Math.max(0,distance)/span)));
    if(index!==current())select(index);status(index);
   });
  }
  function fitArt(){
   media.querySelectorAll('.mxe-scene').forEach(scene=>{
    const [w,h]=dimensions[scene.dataset.scene]||[756,678];
    const scale=Math.min(media.clientWidth/w,media.clientHeight/h);
    scene.style.setProperty('--scroll-art-w',w+'px');scene.style.setProperty('--scroll-art-h',h+'px');
    scene.style.setProperty('--scroll-art-scale',scale);
    scene.style.setProperty('--scroll-art-x',(media.clientWidth-w*scale)/2+'px');
    scene.style.setProperty('--scroll-art-y',(media.clientHeight-h*scale)/2+'px');
   });
  }
  function size(){
   if(!alive)return;
   nav=parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--navigation-height'))||44;
   const view=Math.max(360,document.documentElement.clientHeight-nav);
   span=Math.max(320,view*(mobile.matches?.85:.65));
   section.classList.toggle('mxw-experience-scroll',enabled());
   section.classList.remove('mxw-fit-section');section.style.removeProperty('--canvas-scale');
   section.style.setProperty('--experience-view',view+'px');
   section.style.setProperty('--experience-height',(view+span*items.length)+'px');
   section.style.setProperty('--experience-scale',Math.min(document.documentElement.clientWidth/1440,view/1024));
   fitArt();read();
  }
  function go(index){
   if(!enabled()){select(index);status(index);return;}
   window.scrollTo({top:scrollY+section.getBoundingClientRect().top-nav+Math.max(0,Math.min(items.length-1,index))*span+1,behavior:'instant'});
  }
  root.mxScrollTo=go;
  buttons.forEach((button,i)=>button.addEventListener('click',()=>go(current()+(i?1:-1)),{signal}));
  root.classList.add('mxe-scroll-enhanced');
  window.addEventListener('scroll',read,{passive:true,signal});window.addEventListener('resize',size,{signal});
  mobile.addEventListener('change',size,{signal});
  const ro=new ResizeObserver(fitArt);ro.observe(media);
  document.fonts.ready.then(size);requestAnimationFrame(size);status(Math.max(0,current()));
  cleanup.push(()=>{alive=false;controller.abort();ro.disconnect();cancelAnimationFrame(frame);navigation.remove();hint.remove();delete root.mxScrollTo;root.classList.remove('mxe-scroll-enhanced');section.classList.remove('mxw-experience-scroll');});
 };
})();
